//gera string nesse padrao QbOLlAcFzVh1ech2YeYc
export const generateRandomString = (random?: number): string => {
  const length = random || 20;
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(
      Math.floor((random || Math.random()) * chars.length)
    );
  }
  return result;
};
